import { ReactNode } from "react";
import styled, { keyframes } from "styled-components";

interface FadeInAnimationProps {
  children: ReactNode;
  duration?: number;
  justifyContent?: "center" | "flex-start";
}

export const FadeInAnimation = ({
  children,
  duration = 1,
  justifyContent = "center",
}: FadeInAnimationProps) => {
  return (
    <FadeInContainer className="fade-in" $duration={duration} $justifyContent={justifyContent}>
      {children}
    </FadeInContainer>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FadeInContainer = styled.div<{
  $duration: number;
  $justifyContent: "center" | "flex-start";
}>`
  display: flex;
  flex: 1;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  opacity: 0;
  &.fade-in {
    animation: ${fadeIn} ${(p) => p.$duration}s ease-in forwards;
  }
`;
